export function extractErrorResponse(response) {
    let errorMessageId = "error.unknownError";
    if (response && response.responseJSON) {
        errorMessageId = response.responseJSON.errorMessageId;
    }
    return errorMessageId;
}

export function getDomainFromEmail(email) {
    if (email) {
        let emailParts = email.split("@");
        if (emailParts.length === 2) {
            return emailParts[1];
        }
    }
    return null;
}

// try to match anything within <>, if that fails, try http://emailregex.com/
export function getEmailFromHeaderFrom(headerFrom) {
    if (headerFrom) {
        let angleMatcher = /[^@<\s]+@[^@\s>]+/g;
        let angleMatch = headerFrom.match(angleMatcher);
        if (angleMatch) {
            return angleMatch[angleMatch.length - 1];
        }
        let emailRegex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;
        let emailRegexMatch = headerFrom.match(emailRegex);
        if (emailRegexMatch) {
            return emailRegexMatch[emailRegexMatch.length - 1];
        }
    }
    return null;
}

export const getFriendlyNameFromHeaderFrom = headerFrom => {
    let friendlyName;
    if (headerFrom) {
        friendlyName = headerFrom.match(/(.*)(?=\s<?(.+)@(.+)>?)/g); //remove the " <email>" part from headerFrom field
        if (friendlyName) {
            return friendlyName[0].replace(/^['"]|['"]$/g, ""); //remove starting and ending single or double quotes
        }
    }
    return null;
};

export function copyArrayByValue(original) {
    return JSON.parse(JSON.stringify(original));
}
